import { ErrorResponse } from "../../custom-fetch";
import Alert from "../ui/Alert/Alert";

interface IProps {
  errors: string[];
  style?: React.CSSProperties;
}

const ErrorsAlert: React.FC<IProps> = ({ errors, style }) => {
  if (!errors) return null;
  return (
    <Alert style={{ marginTop: 0, whiteSpace: "pre-wrap", ...style }}>
      {errors.length > 1 ? (
        <ul style={{ margin: 0 }}>
          {errors.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      ) : (
        errors[0]
      )}
    </Alert>
  );
};


interface IError {
  isError: boolean;
  error: ErrorResponse | null;
}

export const combineErrors = (...errors: IError[]) => {
  let messages: string[] = [];
  errors.forEach(error => {
    if (error.isError && error.error && error.error.messages) {
      messages = [...messages, ...error.error.messages];
    }
  });
  return messages;
}

export default ErrorsAlert;
